import { FormContext } from '@bnnvara/forms/src/new_components/BaseForm/FormContext';
import { Checkbox } from '@bnnvara/forms/src/new_components/inputs/Checkbox/Checkbox';
import { TextInput } from '@bnnvara/forms/src/new_components/inputs/TextInput/TextInput';
import { SubmitButton } from '@bnnvara/forms/src/new_components/SubmitButton/SubmitButton';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

import { useAddress } from '../../hooks/useAddress';
import * as S from './styled';

export const ContactDataStep = ({ onSubmit }) => {
  const link = 'https://bnnvara.nl/pagina/algemene-voorwaarden';
  const { partialValidate } = useContext(FormContext);
  const [location, setLocation] = useState({
    houseNumber: '',
    houseNumberAddition: '',
    postalCode: '',
  });
  const { street, city, message } = useAddress(location);

  function updateLocation(event) {
    const { name, value } = event.target;

    if (location[name] === value) {
      return;
    }

    setLocation({
      ...location,
      [name]: value,
    });
  }

  /**
   * Don't cancel the event, we need it to trigger the submit
   */
  async function onClick() {
    const validationResult = await partialValidate([
      'membership',
      'postalCode',
      'houseNumber',
      'houseNumberAddition',
      'street',
      'city',
      'emailAddress',
      'phoneNumber',
      'newsletterSubscription',
      'terms',
    ]);

    const isValid = validationResult.every((field) => field.isValid);

    if (isValid) {
      onSubmit();
    }
  }

  return (
    <>
      <S.Grid fullWidth>
        <GridItem columnEndSm="span 6" columnEndMd="span 4">
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="postalCode"
            label="Postcode"
            validation="required|postalCode"
            autoComplete="postal-code"
            onBlur={updateLocation}
          />
        </GridItem>
        <GridItem
          columnStartSm="1"
          columnEndSm="span 6"
          columnStartMd="5"
          columnEndMd="span 4"
        >
          <TextInput
            fullWidth
            showIsRequired
            type="number"
            name="houseNumber"
            label="Huisnummer"
            validation="required|"
            autoComplete="nope"
            onBlur={updateLocation}
          />
        </GridItem>
        <GridItem
          columnStartSm="7"
          columnEndSm="span 6"
          columnStartMd="9"
          columnEndMd="span 4"
        >
          <TextInput
            fullWidth
            type="text"
            name="houseNumberAddition"
            label="Toevoeging"
            autoComplete="nope"
            onBlur={updateLocation}
          />
        </GridItem>
        {message && (
          <GridItem columnStartSm="1" columnEndSm="span 12">
            <S.Error>Adres niet gevonden, controleer je gegevens</S.Error>
          </GridItem>
        )}
        <GridItem
          columnStartSm="1"
          columnEndSm="span 12"
          style={{ display: street && city ? 'block' : 'none' }}
        >
          <TextInput
            fullWidth
            disabled
            type="text"
            name="street"
            label="Adres"
            validation="required"
            autoComplete="street-address"
            value={street}
          />
          <TextInput
            fullWidth
            disabled
            type="text"
            name="city"
            validation="required"
            autoComplete="city"
            value={city}
          />
        </GridItem>
        <GridItem columnStartSm="1" columnEndSm="span 12">
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="emailAddress"
            label="E-mailadres"
            validation="required|email"
            autoComplete="email"
          />
        </GridItem>
        <GridItem columnStartSm="1" columnEndSm="span 12">
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="phoneNumber"
            label="Telefoonnummer"
            validation="required|phoneNumber"
            autoComplete="tel"
          />
        </GridItem>
      </S.Grid>
      <Checkbox
        name="newsletterSubscription"
        label="Ik wil informatie ontvangen over programma's, evenementen en aanbiedingen van BNNVARA."
      />
      <Checkbox
        name="terms"
        validation="accepted"
        label="Ik ga akkoord met de algemene voorwaarden"
      >
        Ja, Ik ga akkoord met de{' '}
        <S.Link href={link} target="_blank" rel="noopener noreferrer">
          algemene voorwaarden van BNNVARA
        </S.Link>
        .*
      </Checkbox>
      <SubmitButton title="Doorgaan naar betalen" fullWidth onClick={onClick} />
    </>
  );
};

ContactDataStep.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
